module.exports = __webpack_public_path__ + "img/top-10-map.6328a718.webp";